/**
 * 転職意欲: 転職活動中
 */
export const CAREER_MOTIVATION_ID_CURRENTLY_JOB_HUNTING = 1;

/**
 * 転職意欲: 3ヶ月以内に転職したい
 */
export const CAREER_MOTIVATION_ID_WITHIN_THREE_MONTHS = 2;

/**
 * 転職意欲: 半年以内に転職したい）
 */
export const CAREER_MOTIVATION_ID_WITHIN_SIX_MONTHS = 3;

/**
 * 転職意欲: すぐの転職は考えていない
 */
export const CAREER_MOTIVATION_ID_NO_IDEA = 4;

/**
 * 転職意欲: よい求人があれば検討したい
 */
export const CAREER_MOTIVATION_ID_WANT_TO_HEAR = 5;

/**
 * 転職意欲: 未選択
 */
export const CAREER_MOTIVATION_ID_NOT_SELECTED = 6;

/**
 * 転職意欲: キャリアについて考え始めている
 */
export const CAREER_MOTIVATION_ID_CONSIDERING_CAREER = 7;

/**
 * 転職意欲が高い項目のID一覧
 */
export const HIGH_CAREER_MOTIVATION_IDS: Readonly<number[]> = [
  CAREER_MOTIVATION_ID_CURRENTLY_JOB_HUNTING,
  CAREER_MOTIVATION_ID_WITHIN_THREE_MONTHS,
  CAREER_MOTIVATION_ID_WITHIN_SIX_MONTHS,
] as const;

/**
 * マーケティング用の転職意欲が高い項目のID一覧
 */
export const MARKETING_HIGH_CAREER_MOTIVATION_IDS: Readonly<number[]> = [
  ...HIGH_CAREER_MOTIVATION_IDS,
  CAREER_MOTIVATION_ID_WANT_TO_HEAR,
] as const;
